import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { analyticsApi, type ForecastResult } from '../../api/analytics';

export function ForecastCenterPage() {
  const [forecast, setForecast] = useState<ForecastResult | null>(null);
  const [metricKey, setMetricKey] = useState('revenue');
  const [error, setError] = useState('');

  const load = () => {
    void analyticsApi.biForecast(metricKey, 30).then(setForecast).catch((e) => setError(String(e)));
  };

  useEffect(() => { load(); }, [metricKey]);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Forecast Center</h1>
        <Link to="/analytics/bi" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← BI Hub</Link>
      </div>
      <div className="mt-4 flex gap-2">
        {['revenue', 'orders', 'inventory_value'].map((m) => (
          <button key={m} onClick={() => setMetricKey(m)} className={`rounded-lg px-3 py-1 text-sm ${metricKey === m ? 'bg-brand-600 text-white' : 'border dark:border-slate-700'}`}>{m}</button>
        ))}
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {forecast && (
        <div className="mt-6">
          <p className="text-sm text-slate-500">Model: {forecast.model} · Confidence: {(forecast.confidence * 100).toFixed(0)}%</p>
          <div className="mt-4 max-h-96 overflow-y-auto space-y-1">
            {forecast.points.map((p) => (
              <div key={p.date} className="flex justify-between rounded border px-3 py-2 text-sm dark:border-slate-700">
                <span>{p.date}</span>
                <span className="font-medium">{p.value.toLocaleString(undefined, { maximumFractionDigits: 0 })}</span>
                <span className="text-slate-500">{p.lower?.toLocaleString(undefined, { maximumFractionDigits: 0 })} – {p.upper?.toLocaleString(undefined, { maximumFractionDigits: 0 })}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
